<script setup lang="ts">
import { computed } from "vue";

import StatusClassDistributionBar from "@/components/StatusDistribution/StatusClassDistributionBar.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import { isBacklogBoard, isSolutionBoard } from "@/model/board";
import { isDependency } from "@/model/stickyType";
import { useWorkModeStore } from "@/store/workMode";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const isProgressBarVisible = computed(
  () =>
    (isDependency(card) || isBacklogBoard(card.type.origin)) &&
    useWorkModeStore().isExecutionMode &&
    !isSolutionBoard(board.value.type),
);
</script>

<template>
  <div v-if="isProgressBarVisible" class="sticky-note-progress">
    <StatusClassDistributionBar
      :value="card.statusDistribution"
      source-item-type="sticky"
      :filters="{ stickyId: card.id }"
      :title="card.text"
    />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/z-index";
@use "./variables";

.sticky-note-progress {
  position: absolute;
  left: 0;
  right: 0;
  height: variables.$height;
  bottom: variables.$height * -1;
  z-index: z-index.$progress-bar;

  :deep(.stacked-bar-chart .bordered) {
    border: none;
    border-radius: 0 0 20px 20px;
  }
}
</style>
